exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer{background-color:#1b1b1b;color:#fff;padding:3% 0}.footer .footerContent{max-width:600px}.footer .footerContent .logo-knowin{width:300px}.footer .footerContent .logo-thesafezone{width:60px}.footer .footerContent .navigation-links{font-size:19px}.footer .footerContent .copyright{font-size:15px}.footer a{text-decoration:none;color:#fff;cursor:pointer}#cookies_dialog a.more_info{text-decoration:none;color:inherit}#cookies_dialog a.more_info:hover{text-decoration:underline;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/containers/footer/footer.styl
// module id = 90
// module chunks = 1